export const TRUSTPILOT_BUSINESS_UNIT_ID = "5ca4ebfbb7ff9b0001535a37";

// To see the template, go to https://businessapp.b2b.trustpilot.com/trustbox/<TrustpilotTemplate>
export enum TrustpilotTemplate {
  MicroCombo = "5419b6ffb0d04a076446a9af",
  Mini = "53aa8807dec7e10d38f59f32",
  MicroStar = "5419b732fbfb950b10de65e5",
}
